import React, { FC } from 'react';

interface SkeletonGridProps {
  count?: number;
  windowWidth?: number;
}

const SkeletonGrid: FC<SkeletonGridProps> = React.memo(
  ({ count = 6, windowWidth = 600 }) => {
    const skeletonItems = Array.from({ length: count }, (_, index) => (
      <div key={index} className="skeleton-item fade-in">
        <div className="skeleton skeleton-photo"></div>
      </div>
    ));

    return (
      <div
        className="skeleton-grid"
        style={{
          gap: windowWidth > 480 ? '0.25rem' : '0.125rem',
          padding: windowWidth > 480 ? '0.25rem' : '0.125rem',
        }}
      >
        {skeletonItems}
      </div>
    );
  }
);

export default SkeletonGrid;
